import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isDark, setIsDark] = useState(false);

  const toggleTheme = () => {
    setIsDark(!isDark);
    document.documentElement.classList.toggle('dark');
  };

  return (
    <nav className="fixed w-full z-50 bg-background-light dark:bg-background-dark shadow-sm transition-colors duration-300">
      <div className="container mx-auto px-8 py-4 flex justify-between items-center">
        <span className="text-2xl font-bold text-primary-light dark:text-primary-dark">
          322 Project
        </span>
        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg bg-surface-light dark:bg-surface-dark text-text-primary-light dark:text-text-primary-dark hover:opacity-80 transition-all"
        >
          {isDark ? '🌞' : '🌙'}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;